import type { ReactNode } from 'react'
import { Icon } from './Icon'
import { Tooltip } from './Tooltip'

/**
 * Spiegazione a richiesta: un "?" discreto che apre la spiegazione in un tooltip (passaggio del mouse, tastiera,
 * tocco). Prende il posto dei testi descrittivi sempre visibili sotto titoli e campi.
 */
export function HelpTip({ children, label = 'Spiegazione' }: { children: ReactNode; label?: string | undefined }) {
  return (
    <Tooltip label={children} toggleOnClick>
      <button type="button" className="md-helptip" aria-label={label}>
        <Icon name="help" size={18} />
      </button>
    </Tooltip>
  )
}

/**
 * Un sottotitolo è una spiegazione (da mettere nel tooltip) quando è una frase: testo che finisce col punto o
 * lungo. I sottotitoli brevi di dati (cliente · operatore, conteggi, periodi) restano visibili.
 */
export function isExplanation(node: ReactNode): node is string {
  if (typeof node !== 'string') return false
  const t = node.trim()
  return t.length > 60 || /[.:]$/.test(t)
}
